import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";

export interface OrdersModel {
	clientID: string;
	orderList: any[];
	total: number;
}

import { AccountClientDetailsService } from '../../../../service/account-client-edit/account-client-details.service';
import { LimitFlowProposalService } from '../../../../../limit-flow-proposal/service/limit-flow-proposal/limit-flow-proposal.service';

@Component({
	selector: 'app-orders-modal',
	templateUrl: './orders-modal.component.html',
	styleUrls: ['./orders-modal.component.scss'],
	providers: [
		AccountClientDetailsService,
		LimitFlowProposalService
	],
	moduleId: module.id
})
export class OrdersModalComponent extends DialogComponent<OrdersModel, boolean> implements OrdersModel, OnInit {

	// From Model
	clientID: string;
	orderList = [];
	total = 0;
	// From Parents
	token;
	permissoes: any[] = [];
	// From Services
	exposicao: number = 0;
	// Private Props
	acompanharProposta: boolean = false;
	comentario: string = "";
	exposicaoFutura: number = 0;
	ctcs: any[] = [];
	selectedCTC;
	errorMessage;

	constructor(dialogService: DialogService, private accountClientDetailsService: AccountClientDetailsService, private limitFlowProposalService: LimitFlowProposalService) {
		super(dialogService);
	}

	ngOnInit() {
		console.log(this.orderList, this.clientID, "total", this.total);

		this.token = localStorage.getItem('yara.token');
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];

		this.getAccountClientFinancialDetails();
		this.getCTCByAccountClient();
	}

	releaseOrder() {
		const tempObj = {
			Ordens: this.orderList,
			AcompanharProposta: this.acompanharProposta,
			Comentario: this.comentario,
			Total: this.total,
			ContaClienteID: this.clientID,
			CodigoSap: this.selectedCTC
		};

		this.accountClientDetailsService.releaseOrder(tempObj).subscribe(result => {
			if (result.Success) {
				this.result = true;
				this.close();
			} else {
				this.errorMessage = result.Errors;
			}
		}, error => {
			console.log(error);
		});
	}

	getAccountClientFinancialDetails() {
		this.accountClientDetailsService.getAccountClientFinancialDetails(this.token, this.clientID).subscribe(result => {

			for (var key in result.Result.Limites) {
				var obj = result.Result.Limites[key];
				if (obj.EmpresasID === localStorage.getItem('yara.selectedCompany')) {
					this.exposicao = obj.Exposicao;
				}
			}

			this.exposicaoFutura = this.exposicao + this.total;
		}, error => {
			console.log(error);
		});
	}

	getCTCByAccountClient() {
		this.limitFlowProposalService.getCtcByAccountClient(this.clientID).subscribe(result => {
			if (result.Success) {
				this.ctcs = result.Result;
				console.log("getCtcByAccountClient()", result);
			} else {

			}
		}, error => {
			console.log(error);
		});
	}

}


// WEBPACK FOOTER //
// ./src/app/account-client/component/account-client-details/orders/orders-modal/orders-modal.component.ts